/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseSetString } from '../../models/api-response-set-string';

export interface UpdateCompanyEmails$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: Array<string>
}

export function updateCompanyEmails(http: HttpClient, rootUrl: string, params: UpdateCompanyEmails$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseSetString>> {
  const rb = new RequestBuilder(rootUrl, updateCompanyEmails.PATH, 'put');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseSetString>;
    })
  );
}

updateCompanyEmails.PATH = '/v1/api/ui/company/update-emails';
